module.exports = __webpack_public_path__ + "img/popupnew.e5820a4.png";